<template>
  <b-dropdown
    right
    :text="translations[10417]"
    variant="primary"
    size="sm"
    menu-class="outline-none"
  >
    <b-dropdown-item
      v-for="(limit, index) of limitData"
      :key="index"
      @click.stop="setLimit(limit.number)"
      :active="currentLimit === limit.number"
      :disabled="currentLimit === limit.number"
    >
      <span class="dropdown-text">
        {{ limit.text }}
      </span>
    </b-dropdown-item>
    <b-dropdown-item
      @click.stop="setLimit(jobsCount)"
      :active="currentLimit === jobsCount"
      :disabled="currentLimit === jobsCount"
    >
      <span class="dropdown-text">
        {{ translations[10904] }}
      </span>
    </b-dropdown-item>
  </b-dropdown>
</template>

<script lang="ts">
import { AppModule } from '@/store/modules/app';
import { Component, Prop, Vue } from 'vue-property-decorator';

@Component
export default class Limit extends Vue {
  @Prop({ type: Number, required: true }) readonly jobsCount!: number;

  @Prop({ type: Number, required: false }) readonly currentLimit!: number;

  get translations() {
    return AppModule.translation;
  }

  limitData: any = [
    {
      number: 10,
      text: 10,
    },
    {
      number: 20,
      text: 20,
    },
    {
      number: 50,
      text: 50,
    },
    {
      number: 100,
      text: 100,
    },
  ];

  setLimit(limit: number) {
    this.$emit('set-limit', limit);
  }
}
</script>
